var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-bolsa mb-4"},[_c('b-jumbotron',{staticClass:"title_page"},[_c('h1',{staticClass:"text-center font-weight-bold"},[_vm._v("Google Callback")])]),_c('bread-cpv',{staticClass:"adjustment-breadcrumb"}),_c('b-container',{attrs:{"fluid":"xl"}},[_vm._v(" Google Callback ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }